export default "__VITE_ASSET__CYKEP7$b__"